const icon = require('vue-svgicon');
icon.register({
    'legal-entity-i': {
        width: 20,
        height: 20,
        viewBox: '0 0 20 20',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M16.666 18.334H3.332a2.222 2.222 0 01-2.222-2.222V6.111c0-1.226.995-2.222 2.222-2.222h3.334V2.222c0-.307.248-.555.555-.555h5.556c.306 0 .555.248.555.555V3.89h3.334c1.227 0 2.222.996 2.222 2.222V16.112a2.221 2.221 0 01-2.222 2.222zM12.22 2.778H7.777v1.11h4.444v-1.11zM16.666 5c.614 0 1.111.498 1.111 1.112v3.333H2.22V6.112C2.221 5.498 2.719 5 3.332 5h13.334zm-8.89 5.557v2.222h4.445v-2.222H7.777zm5.556 0h4.445v5.555c0 .614-.498 1.111-1.111 1.111H3.332a1.111 1.111 0 01-1.11-1.11v-5.556h4.444v3.333h6.666v-3.333z" _fill="#000"/>`,
    },
});
